import type { CardListItem } from "@hobbyshopify/backend-client";

/** The count a row shows: what was tapped and not yet sent, else what the shop holds. */
export function displayedAvailable(card: CardListItem["card"], edits: Readonly<Record<string, number>>): number {
  return edits[card.id] ?? card.available;
}

/**
 * Tracked cards on the list, priced at what the shop asks. Null while more pages
 * exist: a sum of whatever happens to be loaded is not the stock's value.
 */
export function stockValueCents(
  items: readonly CardListItem[],
  edits: Readonly<Record<string, number>>,
  complete: boolean,
): number | null {
  if (!complete) return null;
  return items.reduce((total, { card }) => {
    if (!card.trackStock || card.currentPriceCents == null) return total;
    return total + card.currentPriceCents * displayedAvailable(card, edits);
  }, 0);
}
